import { useSession } from 'components/auth/useSession'
import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'
import { emptyArrayOf } from 'util/array'

import { permissaoPorTipoTopicoNotificacaoRecord } from './notificacao-context/model-notificacaoContext'
import { useNotificacaoCountContext } from './notificacao-context/useNotificacaoContext'

export function useNotificacaoCount(
  tiposTopicos: Readonly<TipoTopicoNotificacaoEnum[]> = emptyArrayOf<TipoTopicoNotificacaoEnum>()
): number {
  const { hasAuthorization } = useSession()
  const notificacoes = useNotificacaoCountContext()

  const totalNotificacoes = useMemo(() => {
    return tiposTopicos.reduce((acc, tipo) => {
      const permissao = permissaoPorTipoTopicoNotificacaoRecord[tipo]

      if (permissao && !hasAuthorization(permissao)) {
        return acc
      }

      return acc + (notificacoes[tipo] ?? 0)
    }, 0)
  }, [tiposTopicos, notificacoes, hasAuthorization])

  return totalNotificacoes
}
